module.exports = __webpack_public_path__ + "img/1512921493.12d897c1.jpg";